import React from 'react';

const RicosDirectionContext = React.createContext(
  null
);
const RicosDirectionContextProvider = ({
  textDirection,
  children
}) => {
  return /* @__PURE__ */ React.createElement(
    RicosDirectionContext.Provider,
    {
      value: {
        textDirection
      }
    },
    children
  );
};
const RicosDirectionContextConsumer = ({ children }) => /* @__PURE__ */ React.createElement(RicosDirectionContext.Consumer, null, (value) => children(value));

export { RicosDirectionContext, RicosDirectionContextConsumer, RicosDirectionContextProvider };
//# sourceMappingURL=DirectionContext.js.map
